import React, { useState, useEffect } from 'react';
import './ContentGuard.css';

const ContentGuard = ({ section, children }) => {
  const [isLocked, setIsLocked] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const security = localStorage.getItem('stocks4u_content_security');
    if (security) {
      const parsed = JSON.parse(security);
      const sectionConfig = parsed[section];
      if (sectionConfig && sectionConfig.locked) {
        setIsLocked(true);
        setConfig(sectionConfig);
        
        // Check if already unlocked in this session
        const sessionKey = `stocks4u_unlocked_${section}`;
        if (sessionStorage.getItem(sessionKey)) {
          setIsUnlocked(true);
        }
      }
    }
  }, [section]);

  const handleUnlock = (e) => {
    e.preventDefault();
    if (password === config.password) {
      setIsUnlocked(true);
      sessionStorage.setItem(`stocks4u_unlocked_${section}`, 'true');
      setError(false);
    } else {
      setError(true);
      setPassword('');
      // Shake effect
      const input = document.querySelector('.guard-input');
      input?.classList.add('shake');
      setTimeout(() => input?.classList.remove('shake'), 500);
    }
  };

  if (!isLocked || isUnlocked) {
    return children;
  }

  return (
    <div className="content-guard-overlay">
      <div className="guard-card">
        <div className="guard-icon">
          {section === 'blog' ? '✍️' : section === 'tutorials' ? '🎥' : '🎓'}
        </div>
        <h2>Section Locked</h2>
        <p>This content is protected. Please enter the password provided by the administrator to continue.</p>
        
        <form onSubmit={handleUnlock} className="guard-form">
          <div className="guard-input-wrapper">
            <input 
              type="password" 
              className={`guard-input ${error ? 'error' : ''}`}
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            {error && <span className="guard-error-msg">Incorrect password. Please try again.</span>}
          </div>
          <button type="submit" className="guard-btn">
            Unlock Content 🔓
          </button>
        </form>
        
        <div className="guard-footer">
          <p>Authorized Access Only</p>
        </div>
      </div>
    </div>
  );
};

export default ContentGuard;
